export default __webpack_public_path__ + "static/media/FP_Logo_White.7ae961cc.png";